import { mapActions, mapGetters } from 'vuex';
import MaestrosService from '../services/MaestrosService';
import axios from 'axios';
export default {
    namespaced: true,
    state:{},
    getters:{},
    mutations:{},
    methods:{ },
    actions:{
        async getList({state,commit},data) {
            return await MaestrosService.getList(axios,data);
        },
    }
}
